export const state = () => ({
  hasGeneratedVoucher: false,
});

export const getters = {
  hasGeneratedVoucher: state => state.hasGeneratedVoucher,
};

export const mutations = {
  setGeneratedVoucherState(state, data) {
    state.hasGeneratedVoucher = data;
  },
};

export const actions = {
  setGeneratedVoucherState({ commit }, currentState) {
    commit('setGeneratedVoucherState', currentState);
  },
};
